class LayoutToggle extends HTMLElement {
  constructor() {
    super();
    this.columnsMobile = this.getAttribute('data-columns-mobile').split(',');
    this.columnsDesktop = this.getAttribute('data-columns-desktop').split(',');
    this.mobileCurrent = this.getLocalStorageItem()?.columnsMobile | this.getAttribute('data-columns-mobile-current');
    this.desktopCurrent = this.getLocalStorageItem()?.columnsMobile | this.getAttribute('data-columns-desktop-current');
    this.currentLayoutIndexMobile = this.columnsMobile.indexOf(this.mobileCurrent.toString());
    this.currentLayoutIndexDesktop = this.columnsDesktop.indexOf(this.desktopCurrent.toString());

    this.targetElement = document.querySelector(this.getAttribute('data-target'));
    this.lsKey = 'idhl_pcp_layout_columns_2';

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (this.targetElement) {
      this.addEventListener('click', this.handleClick);
      this.hideOverhangingProducts()
    }
  }

  getLocalStorageItem() {
    let object = JSON.parse(localStorage.getItem(this.lsKey));

    if (object) {
      return object;
    }
  }

  createLocalStorageObject() {
    let object = {
      columnsMobile: this.mobileCurrent,
      columnsDesktop: this.desktopCurrent
    };

    return JSON.stringify(object);
  }

  setLocalStorageItem() {
    localStorage.setItem(this.lsKey, this.createLocalStorageObject());
  }

  handleClick() {
    this.updateLayout();
    this.hideOverhangingProducts();
    this.setLocalStorageItem();
    updateProductImageSizes();
  }

  updateLayout() {
    const isMobile = (window.innerWidth <= 749) ? true : false;

    if (isMobile) {
      this.currentLayoutIndexMobile = (this.currentLayoutIndexMobile + 1) % this.columnsMobile.length;
      this.mobileCurrent = this.columnsMobile[this.currentLayoutIndexMobile];
      this.targetElement.setAttribute('data-columns-mobile', this.mobileCurrent);
      this.setAttribute('data-columns-mobile-current', this.mobileCurrent);
    } else {

      this.currentLayoutIndexDesktop = (this.currentLayoutIndexDesktop + 1) % this.columnsDesktop.length;
      this.desktopCurrent = this.columnsDesktop[this.currentLayoutIndexDesktop];
      this.targetElement.setAttribute('data-columns-desktop', this.desktopCurrent);
      this.setAttribute('data-columns-desktop-current', this.desktopCurrent);
    }

    buildFeaturedCSS();
  }

  hideOverhangingProducts() {
    if (this.classList.contains('all-products-loaded')) {
      return;
    }

    const loadingButton = document.querySelector('loading-button');
    const isMobile = (window.innerWidth <= 749) ? true : false;

    const productGridColumns = isMobile ? this.mobileCurrent : this.desktopCurrent;
    const products =  document.querySelectorAll("#product-grid > li");
    const featuredCards = document.querySelectorAll("#product-grid > li.featured-card");
    let products_length = products.length;

    if (isMobile) {
      // componsate for featured card spanning over 2 and 3 columns
      featuredCards.forEach((card) => {
        products_length -= 1;
      });
    }

    for (let i = 0; i < products_length; i++) {
      const productCard = products[i];
      if (!productCard) {
        break;
      }

      if (i >= products_length - (products_length % productGridColumns) && loadingButton) {
        productCard.classList.add('hidden')
      } else {
        productCard.classList.remove('hidden')
      }
    }

    this.updateProductCountsToVisible();
  }

  showAllProducts() {
    const products =  document.querySelectorAll("#product-grid > li");
    products.forEach((product) => {
      product.classList.remove('hidden')
    });

    this.classList.add('all-products-loaded');
    this.updateProductCountsToVisible();
  }

  updateProductCountsToVisible() {
    let visibleProducts = document.querySelectorAll("#product-grid > li:not(.hidden,.featured-card)");
    const productsCountLabels = document.querySelectorAll('[data-products-count-label]');
    productsCountLabels.forEach((label) => {

      label.setAttribute('data-products-count-label', `${visibleProducts.length} products`);
    });

    this.updatePaginationResultMessage(visibleProducts);
  }

  updatePaginationResultMessage(visibleProducts) {
    const loadingButton = document.querySelector('loading-button');
    if (loadingButton) {
      const messageEl = loadingButton.querySelector('.result-count');
      messageEl.textContent = messageEl.dataset.textTemplate.replace('[LOADED]', visibleProducts.length).replace('[TOTAL]', loadingButton.totalProducts);
    }
  }
}

customElements.define('layout-toggle', LayoutToggle);

let drawerOpenDesktopLargestShown = false;
let drawerClosedDesktopLargestShown = false;
let mobileLargestShown = false;

function updateProductImageSizes() {
  const productGridContainer = document.getElementById('ProductGridContainer');
  const productImages = document.querySelectorAll('.product-card__image');

  if (!productGridContainer || productImages.length === 0) return;

  const columnsDesktop = productGridContainer.getAttribute('data-columns-desktop');
  const columnsMobile = productGridContainer.getAttribute('data-columns-mobile');
  const isDrawerOpen = document.querySelector('.facets-side-drawer.active') !== null;

  let desktopSize = '';
  let mobileSize = '';

  // Determine desktop sizes
  if (isDrawerOpen) {
    switch(columnsDesktop) {
      case '3':
        desktopSize = '25.3vw';
        break;
      case '4':
        desktopSize = '19vw';
        break;
      case '5':
        desktopSize = '15.2vw';
        break;
      case '6':
        desktopSize = '12.6vw';
        break;
    }
  } else {
    switch(columnsDesktop) {
      case '3':
        desktopSize = '32vw';
        break;
      case '4':
        desktopSize = '24vw';
        break;
      case '5':
        desktopSize = '19vw';
        break;
      case '6':
        desktopSize = '16vw';
        break;
    }
  }

  // Determine mobile sizes
  switch(columnsMobile) {
    case '1':
      mobileSize = '92.5vw';
      break;
    case '2':
      mobileSize = '46vw';
      break;
    case '3':
      mobileSize = '30.5vw';
      break;
  }


  if (isDrawerOpen && drawerOpenDesktopLargestShown && window.innerWidth > 750) {
    return;
  } else if (!isDrawerOpen && drawerClosedDesktopLargestShown && window.innerWidth > 750) {
    return;
  } else if (mobileLargestShown && window.innerWidth <= 749) {
    return;
  }

  // Construct the sizes attribute with media queries
  const sizesValue = `(max-width: 749px) ${mobileSize}, ${desktopSize}`;

  // Update the sizes attribute for all product images
  productImages.forEach(img => {
    if (img.getAttribute('sizes') === sizesValue) return;
    img.setAttribute('sizes', sizesValue);

    // Clone and replace the image to force a re-render
    const clone = img.cloneNode(true);
    img.parentNode.replaceChild(clone, img);
  });

  if (isDrawerOpen && columnsDesktop === '3' && window.innerWidth > 750) {
    drawerOpenDesktopLargestShown = true;
  } else if (!isDrawerOpen && columnsDesktop === '3' && window.innerWidth > 750) {
    drawerClosedDesktopLargestShown = true;
  }

  if (columnsMobile === '1' && window.innerWidth <= 749) {
    mobileLargestShown = true;
  }
}


// window.addEventListener('load', updateProductImageSizes);
// window.addEventListener('resize', updateProductImageSizes);

const facetsDrawer = document.querySelector('.facets-side-drawer');
if (facetsDrawer) {
  facetsDrawer.addEventListener('transitionend', updateProductImageSizes);
}

